import { EntityBase } from "@app/common-codes/_models/EntityBase";
import { IEntityMetaData } from "@app/common-codes/_models/IEntityMetaData";
import { Validation } from "@app/common-codes/decorators/EntityDecorators";
import { RegexType } from "@app/common-codes/services/RegexPatternLibrary";



export class ValidationCodeEntity extends EntityBase {
  constructor() {
    super();
    this.id = Date.now();
  }
  override GetType(): IEntityMetaData {
    return ValidationCodeEntity.getMetaData();
  }
  override id: any;
  static override getMetaData(): IEntityMetaData {
    const baseMetaData = super.getMetaData();
    return {
      ...baseMetaData,
      EndPoint: "/validationCode",
      UseTokenCheck: false
    };
  }

  @Validation({  propertyType: `${RegexType.NorthAmericanPhone}|${RegexType.Email}`, validationErrorMessage: 'messages.field-validation-errors.phone-or-email' })
  identificationData?: string;

  @Validation({ maxLength: 15, minLength: 6, propertyType: `${RegexType.NorthAmericanPhone}|${RegexType.EuropeanPhone}` })
  phoneNumber?: string;

  @Validation({ maxLength: 255, minLength: 6, propertyType: `${RegexType.Email}` })
  email?: string;
  languageId!: number;
  validationCode?: string;
  timezoneOffset?: number;
  messages: { [key: string]: string } = {};
}
